import { css } from 'styled-components';

import type { ITypography } from '../types';

const TestimonialsQuote = css<ITypography>``;

export default TestimonialsQuote;
